<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body col-md-12 mx-right">
            <div class="row mt-4" v-if="!isLoading">
              <div class="col-md-3 text-center">
                <div class="img img-responsive">
                  <img v-if="user.picture !== null" :src="load_image(user.picture_medium)" style="border-radius: 8px"
                    alt="" class="img-fluid" />
                  <img v-else src="@/assets/images/users/default.svg" style="border-radius: 8px" alt=""
                    class="img-fluid" />
                  <div class="col-sm-6 col-md-4 col-xl-3">
                    <img v-if="user.picture != null" :src="process + user.picture_medium" style="border-radius: 10px"
                      alt="" />
                    <div class="my-4 text-center">
                      <b-modal id="modal-lg" size="md" :title="$t('pages.users.cropper.title')" title-class="font-18"
                        hide-footer>
                        <p class="text-muted text-center">
                          {{$t('pages.users.cropper.deposit')}} :
                        </p>
                        <div class="text-center">
                          <vue-avatar :width="300" :height="300" :rotation="rotation" :borderRadius="borderRadius"
                            :scale="scale" ref="vueavatar" @vue-avatar-editor:image-ready="onImageReady">
                          </vue-avatar>
                          <br />
                          <label>
                            Zoom : {{ scale }}x
                            <br />
                            <input type="range" min="1" max="3" step="0.02" v-model.number="scale" />
                          </label>
                        </div>
                        <form enctype="multipart/form-data">
                          <div class="col-10 mb-2 mx-auto">
                            <div class="row">
                              <br />
                              <div class="col-md-12 col text-center">
                                <button v-if="!this.isLoadingProfile" type="submit"
                                  class="btn btn-primary btn-block text-center" @click.prevent="updatePicture">
                                  {{ $t("pages.users.save") }}
                                </button>
                                <button class="btn btn-primary btn-block text-center" type="button" v-else disabled>
                                  <span class="spinner-border spinner-border-sm" role="status"
                                    aria-hidden="true"></span>
                                  {{ $t("pages.users.update") }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </b-modal>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <table class="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <td>
                        <b>{{ $t("pages.users.firstname") }}</b>
                      </td>
                      <td>{{ user.firstname }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("pages.users.lastname") }}</b>
                      </td>
                      <td>{{ user.lastname }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("pages.users.mail") }}</b>
                      </td>
                      <td>{{ user.email }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("pages.users.phone") }}</b>
                      </td>
                      <td>{{ user.phone }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("pages.users.adress") }}</b>
                      </td>
                      <td>{{ user.address }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("pages.users.status") }}</b>
                      </td>
                      <td>
                        <div v-if="user.actif">
                          <span class="badge badge-success">
                            {{ $t("pages.users.activeUser") }}
                          </span>
                        </div>
                        <div v-else>
                          <span class="badge badge-warning">
                            {{ $t("pages.users.deactivateUser") }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="mt-4 mb-3">
                  <div class="row">
                    <div class="col-md-12">
                      <router-link :to="{ path: `/users/edit/${user.id}` }" class="btn btn-primary mr-2">{{
                      $t("pages.users.edit") }}</router-link>
                      <router-link :to="{ name: 'Users' }" class="btn btn-light">{{ $t("pages.users.back") }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row p-4" v-else>
              <div v-if="isLoading" style="margin: 26vh">
                <loading :active.sync="isLoading" :can-cancel="false" loader="dots" color="rgb(20, 80, 144)"
                  :width="100" :is-full-page="false">
                </loading>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import Loading from "vue-loading-overlay";
import { VueAvatar } from "vue-avatar-editor-improved";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Users",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    VueAvatar,
    Loading,
  },

  data() {
    return {
      title: "pages.users.person",
      isLoading: false,
      isDeleting: false,
      imageLink: "",
      isLoadingProfile: false,
      profile: {
        picture: null,
        imageCropped: null,
      },
      mime_type: "",
      rotation: 0,
      scale: 1,
      borderRadius: 0,
    };
  },
  methods: {
    ...mapActions(["deleteUser", "getUserById", "updateUserPicture"]),
    onDelete(id) {
      if (this.$can("delete", "users")) {
        this.$toasted.clear();
        this.$confirm(
          `Voulez-vous supprimer l'utilisateur ${this.user.firstname} ?`
        ).then(() => {
          this.deleteUser(id).then((deleted) => {
            if (deleted) {
              this.isDeleting = true;
              this.$toasted.success(this.$t('pages.users.actions.deleted'));
              this.$router.push({ name: "Users" });
            } else {
              this.isDeleting = false;
            }
          });
        });
      } else {
        this.$toasted.error(this.$t('pages.unauthorized.forbidden_1'));
      }
    },
    updatePicture() {
      if (this.$refs.vueavatar.changed) {
        this.isLoadingProfile = true;
        this.imageCropped = this.$refs.vueavatar.getImage().toDataURL();
        const formData = new FormData();
        this.$refs.vueavatar.getImage().toBlob((blob) => {
          formData.append("picture", blob, "image.png");
          formData.append("type", this.mime_type);
          this.updateUserPicture(formData)
            .then((response) => {
              if (response.status === 200) {
                this.profile.picture = null;
                this.$toasted.success(this.$t("pages.profile.picture.updated"));
                this.closeModal();
                this.isLoadingProfile = false;
                this.user = response.data.user;
              } else {
                this.isLoadingProfile = false;
                this.$toasted.error(this.$t('pages.unauthorized.error_0'));
              }
            })
            .catch(() => {
              this.isLoadingProfile = false;
              this.$toasted.error(this.$t('pages.unauthorized.error_0'));
            });
        }, this.mime_type);
      } else {
        this.$toasted.error(this.$t("pages.profile.picture.error"));
      }
    },

    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
    onImageReady() {
      this.scale = 1;
      this.rotation = 0;
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user.userRead,
    }),
  },
  created() {
    if (this.$can("read", "users")) {
      this.isLoading = true;
      this.getUserById(this.$route.params.id).then((loaded) => {
        if (loaded) {
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
    }
  },
};
</script>